module.exports = __webpack_public_path__ + "b99d016f9deaed66ab09887011b9f849.svg";